<template>
    <div data-classification="button" data-type="submit" class="formulate-input">
        <div class="formulate-input-wrapper">
            <div data-type="submit" class="formulate-input-element formulate-input-element--submit btn-custom">
                <button class="btn" v-ripple type="button" @click="formHandler" :disabled="hasErrors">
                    <span class="formulate-input-element--submit--label">
                        {{ title }}
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FormulateButton",

    components: {},

    props: ["formHandler", "hasErrors", "title"],

    data: function () {
        return {};
    },
};
</script>
